<template>
  <div class="logo" @mouseenter="logoHovered = true" @mouseleave="logoHovered = false">
    <img class="logo-image" alt="logo" :src="props.logoSrc" />
    <TooltipStandard
      v-if="hoverText.length && logoHovered"
      arrowPosition="top-left"
      :text="hoverText"
      :positionAbsoulute="true"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import TooltipStandard from '@/design-system/atoms/TooltipStandard.vue'

const props = defineProps({
  hoverText: { type: String, default: '' },
  logoSrc: { type: String, default: '' }
})
const logoHovered = ref<boolean>(false)
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
.logo {
  display: flex;
  place-items: center;
  height: variables.$logo-height;
  width: variables.$logo-width;
  position: relative;
}
.logo-image {
  max-height: 100%;
  max-width: 100%;
}
</style>
